<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const baseConfirmController = useBaseConfirmController();
const {
  isOpen,
  title,
  message,
  isMessageComponent,
  confirmButtonLabel,
  cancelButtonLabel,
} = storeToRefs(baseConfirmController);

const confirm = (accept: boolean) => {
  baseConfirmController.close();
  baseConfirmController.savedResolver(accept);
};

const reject = () => {
  baseConfirmController.close();
  baseConfirmController.savedReject.value();
};
</script>

<template>
  <Dialog v-model:open="isOpen" @close="confirm(false)" class="bg-black/50">
    <DialogTrigger class="hidden">
      <slot name="trigger" />
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          <slot name="title">
            {{ title }}
          </slot>
        </DialogTitle>
        <DialogDescription>
          <slot name="description">
            <div>
              <component v-if="isMessageComponent" :is="message" />
              <span v-else>{{ message }}</span>
            </div>
          </slot>
        </DialogDescription>
      </DialogHeader>
      <slot name="content" />
      <DialogFooter>
        <BaseOutlinedButton
          @click="confirm(false)"
          color="danger"
          class="w-[91px] !h-[35px]"
        >
          {{ cancelButtonLabel }}
        </BaseOutlinedButton>
        <BaseButton @click="confirm(true)" class="w-[91px] !h-[35px]">
          {{ confirmButtonLabel }}
        </BaseButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<style scoped></style>
